import React, { Component } from 'react';
import { EventEmitter } from 'fbemitter';

import auth from '../Authentication/Auth';

const authEvents = new EventEmitter();

class FuelFarmCreatePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: false,
    };
  }

  handleToggle() {
    this.setState({ drawerOpen: !this.state.drawerOpen });
  }

  render() {
    return (
      <div className="app">

        <main className="page-content">
          <div className="normal-page-header">
            <h1 className="left">Create Fuel Farm</h1>
            <div className="clear" />
          </div>
          <section>
            Content will be here.
          </section>
        </main>
      </div>
    );
  }
}


// App.contextTypes = {
//   router: React.PropTypes.object
// };

export default FuelFarmCreatePage;




// WEBPACK FOOTER //
// ./src/Containers/FuelFarm/FuelFarmCreatePage.js